/* eslint-disable no-underscore-dangle */
/* eslint-disable no-case-declarations */
import React from "react";
import PropTypes from "prop-types";
import _ from "lodash";
import {withResizeDetector} from "react-resize-detector";
/* Components */
import ModalDefault from "../../../common/modal/modal-default";
import Gauge from "../../../common/charts/gauge/gauge";
import WidgetEmpty from "../empty-widget-content/empty-widget-content";
import Loader from "../../../common/loader/Loader";
import CountForm from "./CountForm";
/* Services */
import DashboardService from "../../../../services/dashboard-service";
/* Util */
import {
    auditPoliciesColumnConfig,
    deviceManagerDevicesColumnConfig,
    configDriftAndAuditDevicesColumnConfig,
    osManagerDevicesColumnConfig,
    filesColumnConfig,
    osPlansColumnConfig,
    schedulesColumnConfig,
} from "../../../../pagingfeed";
import {DATA_TYPE_NAMES, CONTENT_TYPE} from "../widget-constants";
/* Helpers */
import {getSolutionLabel} from "../../../../helpers/chart-helpers";
import {isUserWithDashboardViewerRole} from "../../../../helpers/dashboard-helpers";
import {goToSolutions, shutdownFeed} from "../widget-helpers";
/* Styles */
import "./count.scss";
import WidgetHeader from "../widget-header/WidgetHeader";
import WidgetHeaderButton from "../widget-header/widget-header-button/WidgetHeaderButton";

const INITIAL_VALUES = {
    viewMode: {value: "count", label: "Count"},
    filter: {
        humanQuery: {},
        mongoQuery: {},
    },
    filterName: "",
    columnsConfig: {},
    data: {},
    dataType: null,
};

class Count extends React.PureComponent {
    constructor(props) {
        super(props);
        this.parentRef = React.createRef();

        this.customFieldColumns = {};
        this.allDataFeed = null;
        this.filteredDataFeed = null;
        this.state = {
            formData: {
                title: this.props.data.title,
                dataType: this.props.data.config.dataType || INITIAL_VALUES.dataType,
                filter: this.props.data.config.filter || INITIAL_VALUES.filter,
                filterName: this.props.data.config.filterName
                    ? this.props.data.config.filterName
                    : INITIAL_VALUES.filterName,
                viewMode: this.props.data.config.viewMode
                    ? this.props.data.config.viewMode
                    : INITIAL_VALUES.viewMode,
            },
            tempConfigData: {
                title: this.props.data.title,
                dataType: this.props.data.config.dataType || INITIAL_VALUES.dataType,
                filter: this.props.data.config.filter || INITIAL_VALUES.filter,
                filterName: this.props.data.config.filterName
                    ? this.props.data.config.filterName
                    : INITIAL_VALUES.filterName,
                viewMode: this.props.data.config.viewMode
                    ? this.props.data.config.viewMode
                    : INITIAL_VALUES.viewMode,
                columnsConfig: INITIAL_VALUES.columnsConfig,
            },
            isSettingsModalShown: false,
            columnsConfig: INITIAL_VALUES.columnsConfig,
            chartData: null,
            allData: INITIAL_VALUES.data,
            filteredData: INITIAL_VALUES.data,
            isLoadingData: true,
            isLoadingColumnConfig: false,
            isGaugeSelected: !this.props.data.config.isGaugeSelected
                ? this.props.data.config.isGaugeSelected
                : true,
        };
    }

    componentDidMount() {
        const dataType = this.state.formData.dataType;
        const feedFilter = this.state.formData.filter;
        if (dataType) {
            this.initFeeds(dataType, feedFilter);
        } else {
            this.setState({isLoadingData: false});
        }
    }

    componentWillUnmount() {
        this.shutdownFeeds();
    }

    getAllDataFeedState = (dataType) => {
        return {
            label: dataType.label,
            total: this.allDataFeed.totalEntities,
        };
    };

    setAllDataFeedState = (dataType) => {
        this.setState((state) => {
            const newState = {
                ...state,
            };

            const feedState = this.getAllDataFeedState(dataType);
            newState.allData = {
                ...state.allData,
                ...feedState,
            };

            return newState;
        });
    };

    initAllDataFeed = async (dataType) => {
        this.allDataFeed = await this.feedFactory(dataType, INITIAL_VALUES.filter, () =>
            this.setAllDataFeedState(dataType)
        );
    };

    getFilteredDataFeedState = (dataType) => {
        return {
            label: dataType.label,
            total: this.filteredDataFeed.totalEntities,
        };
    };

    setFilteredDataFeedState = (dataType) => {
        this.setState((state) => {
            const newState = {
                ...state,
            };

            const feedState = this.getFilteredDataFeedState(dataType);
            newState.filteredData = {
                ...state.filteredData,
                ...feedState,
            };

            return newState;
        });
    };

    initFilteredFeed = async (dataType, feedFilter) => {
        this.filteredDataFeed = await this.feedFactory(dataType, feedFilter, () =>
            this.setFilteredDataFeedState(dataType)
        );
    };

    initFeeds = async (dataType, feedFilter) => {
        await this.initAllDataFeed(dataType);

        const hasFilteredFeed = Object.keys(feedFilter).length > 0;
        if (hasFilteredFeed) {
            await this.initFilteredFeed(dataType, feedFilter);
        }

        this.setState((state) => {
            const newState = {
                ...state,
            };

            const allFeedState = this.getAllDataFeedState(dataType);
            newState.allData = {
                ...newState.allData,
                ...allFeedState,
            };

            if (hasFilteredFeed) {
                const filteredFeedState = this.getFilteredDataFeedState(dataType);
                newState.filteredData = {
                    ...newState.filteredData,
                    ...filteredFeedState,
                };
            }

            newState.isLoadingData = false;

            return newState;
        });
    };

    shutdownFeeds = async () => {
        await this.shutdownAllDataFeed();
        await this.shutdownFilteredDataFeed();
    };

    shutdownAllDataFeed = async () => {
        if (this.allDataFeed) {
            await shutdownFeed(this.allDataFeed);
            this.allDataFeed = null;
        }
    };

    shutdownFilteredDataFeed = async () => {
        if (this.filteredDataFeed) {
            await shutdownFeed(this.filteredDataFeed);
            this.filteredDataFeed = null;
        }
    };

    changeAllColumnsConfig = async (dataType) => {
        let tempColumnsConfig;

        switch (dataType.value) {
            case DATA_TYPE_NAMES.AUDIT_POLICIES:
                tempColumnsConfig = auditPoliciesColumnConfig;
                break;
            case DATA_TYPE_NAMES.DEVICES:
                tempColumnsConfig = await this.getSpreadedColumnConfig(
                    dataType,
                    deviceManagerDevicesColumnConfig.getColumnConfig()
                );
                break;
            case DATA_TYPE_NAMES.FILES:
                tempColumnsConfig = await this.getSpreadedColumnConfig(dataType, filesColumnConfig);
                break;
            case DATA_TYPE_NAMES.OS_PLANS:
                tempColumnsConfig = osPlansColumnConfig;
                break;
            case DATA_TYPE_NAMES.SCHEDULES:
                tempColumnsConfig = schedulesColumnConfig;
                break;
            default:
                tempColumnsConfig = INITIAL_VALUES.columnsConfig;
        }

        return _.cloneDeep(tempColumnsConfig);
    };

    async getSpreadedColumnConfig(dataType, columnConfig) {
        if (!_.isEmpty(columnConfig)) {
            const columnConfigCopy = _.cloneDeep(columnConfig);
            switch (dataType.value) {
                case DATA_TYPE_NAMES.DEVICES:
                    break;
                case DATA_TYPE_NAMES.FILES:
                    columnConfigCopy.pathId.context.osImagePaths = this.props.osPaths;
                    break;
                default:
                    break;
            }
            return columnConfigCopy;
        }

        return columnConfig;
    }

    feedFactory = async (dataType, feedFilter, onFeedChange) => {
        let feed = null;

        switch (dataType.value) {
            case DATA_TYPE_NAMES.AUDIT_POLICIES:
                feed = await DashboardService.getAuditPolicies({}, feedFilter);
                break;
            case DATA_TYPE_NAMES.DEVICES:
                feed = await DashboardService.getDevices({}, feedFilter);
                break;
            case DATA_TYPE_NAMES.FILES:
                feed = await DashboardService.getFiles({}, feedFilter);
                break;
            case DATA_TYPE_NAMES.OS_PLANS:
                feed = await DashboardService.getOsPlans({}, feedFilter);
                break;
            case DATA_TYPE_NAMES.SCHEDULES:
                feed = await DashboardService.getSchedules({}, feedFilter);
                break;
            default:
                feed = null;
        }

        feed.on("RefreshLinesNumber", onFeedChange);

        return feed;
    };

    toggleSettingsModal = async (e) => {
        e.stopPropagation();

        let tempColumnsConfig = {};

        const dataType = this.state.formData.dataType;
        if (dataType) {
            tempColumnsConfig = await this.changeAllColumnsConfig(dataType);
        }

        this.setState({
            tempConfigData: {
                ...this.state.tempConfigData,
                columnsConfig: tempColumnsConfig,
                // filter: INITIAL_VALUES.filter,
                filter: {...this.state.formData.filter},
                dataType: {...dataType},
            },
            isSettingsModalShown: !this.state.isSettingsModalShown,
        });
    };

    handleSave = async (values) => {
        const dataType = values.dataType;
        const stateDataType = this.state.formData.dataType;
        const filter = values.filter;

        this.setState({
            isLoadingData: true,
        });

        if (stateDataType && stateDataType.value !== dataType.value) {
            await this.shutdownFeeds();
        }

        if (!this.allDataFeed) {
            await this.initAllDataFeed(dataType);
        }

        if (this.filteredDataFeed) {
            await this.shutdownFilteredDataFeed();
        }

        const filtersExist = Object.keys(filter).length > 0;
        if (filtersExist) {
            await this.initFilteredFeed(dataType, filter);
        }

        this.setState(
            (state) => {
                const newState = {
                    ...state,
                };

                const allFeedState = this.getAllDataFeedState(dataType);
                newState.allData = {
                    ...newState.allData,
                    ...allFeedState,
                };

                newState.filteredData = INITIAL_VALUES.data;
                if (filtersExist) {
                    const filteredFeedState = this.getFilteredDataFeedState(dataType);
                    newState.filteredData = {
                        ...newState.filteredData,
                        ...filteredFeedState,
                    };
                }
                newState.formData = values;
                newState.columnsConfig = this.state.tempConfigData.columnsConfig;
                newState.isSettingsModalShown = false;
                newState.isLoadingData = false;

                return newState;
            },
            () => {
                this.props.onUpdate({
                    ...this.props.data,
                    title: this.state.formData.title,
                    config: {
                        ...this.props.data.config,
                        dataType: this.state.formData.dataType,
                        filter: this.state.formData.filter,
                        filterName: this.state.formData.filterName,
                        viewMode: this.state.formData.viewMode,
                        filteredDataLegend: this.state.filteredDataLegend,
                    },
                });
            }
        );
    };

    handleDataTypeChange = (field, props) => async (value) => {
        this.setState({isLoadingColumnConfig: true});
        const tempColumnsConfig = await this.changeAllColumnsConfig(value);

        this.setState({
            tempConfigData: {
                ...this.state.tempConfigData,
                [field]: value,
                columnsConfig: tempColumnsConfig,
                filter: INITIAL_VALUES.filter,
            },
            isLoadingColumnConfig: false,
        });

        props.setFieldValue(field, value);
        props.setFieldValue("filter", INITIAL_VALUES.filter);
        props.setFieldValue("filterName", INITIAL_VALUES.filterName);
    };

    handleFormFieldChange = (field, props) => (value) => {
        this.setState({
            tempConfigData: {
                ...this.state.tempConfigData,
                [field]: value,
            },
        });
        props.setFieldValue(field, value);
    };

    handleChartRedirect = () => {
        const openSolutionInNewTab = this.props.openSolutionsInNewTab;

        if (this.props.isMobileDevice) {
            return;
        }
        if (this.props.isEditAllowed || isUserWithDashboardViewerRole()) {
            return;
        }
        let obj = {
            filter: {},
        };

        if (Object.keys(this.state.formData.filter).length > 0) {
            obj = {
                ...obj,
                filter: this.state.formData.filter.mongoQuery,
            };
        }
        if (this.state.formData.dataType.value === DATA_TYPE_NAMES.DEVICES) {
            obj = {
                ...obj,
                groupingField: {},
            };
        }
        goToSolutions(
            obj,
            this.state.formData.dataType.value,
            this.props.isMobileDevice,
            undefined,
            openSolutionInNewTab
        );
    };

    getContentType = () => {
        if (this.state.errorMessage) {
            return CONTENT_TYPE.ERROR;
        }
        if (!this.state.formData.dataType) {
            return CONTENT_TYPE.NOT_INITIALIZED;
        }
        if (Object.keys(this.state.allData).length || Object.keys(this.state.filteredData).length) {
            return CONTENT_TYPE.DATA;
        }
        return CONTENT_TYPE.EMPTY;
    };

    showMessage = () => {
        return this.state.allData.total ? (
            <div
                style={{
                    fontSize: `${this.props.height / 24}px`,
                    top: this.props.height > this.props.width ? "18%" : "10%",
                }}
                className={`glu-count-widget__filter-name
                                ${
                                    this.state.formData.filterName.length === 0
                                        ? "glu-count-widget__filter-name--none"
                                        : ""
                                }`}
            >
                {this.state.formData.filterName}
            </div>
        ) : (
            <div
                style={{
                    fontSize: `${this.props.height / 24}px`,
                    top: this.props.height > this.props.width ? "18%" : "10%",
                }}
                className="glu-count-widget__filter-name"
            >
                There is no data for selected org
            </div>
        );
    };

    renderLabel = () => {
        let dataTypeLabel = this.state.formData.dataType.label.toLowerCase();
        if (dataTypeLabel === "os plans") {
            dataTypeLabel = "OS plans";
        }
        const countViewFilteredLabel = `${
            this.state.formData.filter.mongoQuery ? `out of ${this.state.allData.total} ` : ""
        }${dataTypeLabel}
        `;
        return countViewFilteredLabel;
    };

    getFontDivider = () => {
        let fontDivider = 24;
        if (this.props.isMobileDevice) {
            fontDivider = 36;
        }
        return fontDivider;
    };

    getFontDivisor = () => {
        let divisor = this.props.height;
        if (this.props.height > this.props.width) {
            divisor = this.props.width;
        }
        return divisor;
    };

    getContentBodyClassNames = () => {
        let className = "glu-content__body";
        if (this.state.formData.viewMode.value === "gauge") {
            className += " glu-content__body--overflow-unset";
        }
        return className;
    };

    renderContent = () => {
        switch (this.getContentType()) {
            case CONTENT_TYPE.NOT_INITIALIZED:
                return (
                    <WidgetEmpty
                        isEditAllowed={this.props.isEditAllowed}
                        showSettingsModal={this.toggleSettingsModal}
                    />
                );
            case CONTENT_TYPE.ERROR:
                return (
                    <WidgetEmpty
                        isEditAllowed={this.props.isEditAllowed}
                        showSettingsModal={this.toggleSettingsModal}
                        text={this.state.errorMessage || "Something went wrong."}
                    />
                );
            case CONTENT_TYPE.EMPTY:
                return (
                    <WidgetEmpty
                        isEditAllowed={this.props.isEditAllowed}
                        showSettingsModal={this.toggleSettingsModal}
                        text="No data for specified configuration"
                    />
                );
            case CONTENT_TYPE.DATA:
                return (
                    <>
                        <div
                            className="glu-content__section
                                    glu-content__separator
                                    glu-content__separator--inner
                                    glu-content__separator--overlay
                                    glu-count"
                            ref={this.parentRef}
                        >
                            <>
                                {this.showMessage()}
                                {this.state.formData.viewMode.value === "count" ? (
                                    <div className="glu-count__text">
                                        <div
                                            className="glu-count__text--big"
                                            style={{
                                                fontSize: `${
                                                    this.getFontDivisor() / this.getFontDivider()
                                                }rem`,
                                            }}
                                        >
                                            {this.state.filteredData.total ||
                                            this.state.filteredData.total === 0
                                                ? this.state.filteredData.total
                                                : this.state.allData.total}
                                        </div>
                                        <div
                                            className="glu-count__text--small"
                                            style={{fontSize: `${this.getFontDivisor() / 140}rem`}}
                                        >
                                            {this.renderLabel()}
                                        </div>
                                    </div>
                                ) : (
                                    <Gauge
                                        parentHeight={this.props.height}
                                        parentWidth={this.props.width}
                                        gaugeData={this.state.allData}
                                        filteredData={
                                            this.state.filteredData.total ||
                                            this.state.filteredData.total === 0
                                                ? this.state.filteredData.total
                                                : this.state.allData.total
                                        }
                                        max={this.state.allData.total}
                                        goToSolution={this.handleChartRedirect}
                                    />
                                )}
                            </>
                        </div>
                    </>
                );
            default:
                return null;
        }
    };

    render() {
        const dataTypeValue = this.state.formData.dataType
            ? this.state.formData.dataType.value
            : "";
        return (
            <>
                <div className="glu-dashboard-card glu-content">
                    {this.state.isLoadingData && <Loader />}
                    <WidgetHeader
                        isEditAllowed={this.props.isEditAllowed}
                        title={this.state.formData.title}
                        height={this.props.height}
                        width={this.props.width}
                        showWidgetInfo={this.props.showWidgetInfo(this.props.data)}
                        openConfiguration={this.toggleSettingsModal}
                        onRemove={this.props.onRemove(this.props.data)}
                        onClone={this.props.onClone(this.props.data)}
                    >
                        <WidgetHeaderButton
                            showButton={
                                Object.keys(this.state.allData).length &&
                                !this.props.isEditAllowed &&
                                !this.props.isMobileDevice &&
                                !isUserWithDashboardViewerRole()
                            }
                            iconName="exit-from-the-app"
                            onClick={this.handleChartRedirect}
                            hoverTooltip={`Open in ${getSolutionLabel(dataTypeValue)}`}
                        />
                    </WidgetHeader>
                    <div className={this.getContentBodyClassNames()}>
                        {!this.state.isLoadingData && this.renderContent()}
                    </div>
                </div>
                {this.state.isSettingsModalShown && (
                    <ModalDefault isOpen={this.state.isSettingsModalShown}>
                        <div className="glu-modal-content">
                            <div className="glu-modal__header">
                                <div className="glu-modal__title glu-flex-grow">
                                    {this.state.formData.title}
                                </div>
                                <div className="glu-flex-shrink">
                                    <button
                                        aria-label="close"
                                        type="button"
                                        className="glu-btn-link g-icon g-icon-close"
                                        onClick={this.toggleSettingsModal}
                                    />
                                </div>
                            </div>
                            <CountForm
                                onFormSubmit={this.handleSave}
                                onCancel={this.toggleSettingsModal}
                                initialValues={this.state.formData}
                                tempConfigData={this.state.tempConfigData}
                                handleFormFieldChange={this.handleFormFieldChange}
                                handleDataTypeChange={this.handleDataTypeChange}
                                isLoadingColumnConfig={this.state.isLoadingColumnConfig}
                            />
                        </div>
                    </ModalDefault>
                )}
            </>
        );
    }
}

Count.propTypes = {
    data: PropTypes.objectOf(PropTypes.any).isRequired,
    isEditAllowed: PropTypes.bool,
    onRemove: PropTypes.func,
    onUpdate: PropTypes.func,
    showWidgetInfo: PropTypes.func,
    onClone: PropTypes.func,
    isLightThemeActive: PropTypes.bool.isRequired,
    osMap: PropTypes.arrayOf(PropTypes.any),
    osPaths: PropTypes.objectOf(PropTypes.any),
    fileServersMap: PropTypes.arrayOf(PropTypes.any),
    selectedOrganization: PropTypes.objectOf(PropTypes.any),
    isMobileDevice: PropTypes.bool,
};

Count.defaultProps = {
    isEditAllowed: false,
    onRemove: undefined,
    onUpdate: undefined,
    showWidgetInfo: undefined,
    onClone: undefined,
    osMap: [],
    osPaths: {},
    fileServersMap: [],
    selectedOrganization: null,
    isMobileDevice: false,
};

export default withResizeDetector(Count);
